import React from "react";
import { Box } from "@mui/material";

interface NoRowsOverlayProps {
  message: string;
}

/** DataGrid にデータがない場合のオーバーレイ表示 */
export const NoRowsOverlay: React.FC<NoRowsOverlayProps> = ({ message }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
    }}
  >
    {message}
  </Box>
);
